import { Link } from 'react-router-dom';
import { SWC_PROMISE } from '@/data/promise';
import { TIERS } from '@/data/tiers';
import TierCard from '@/components/pricing/TierCard';
import { useAuth } from '@/hooks/useAuth';

const STATS: readonly [string, string][] = [
  ['247', 'Parts Authenticated'],
  ['100%', 'Money-Back Guarantee'],
  ['0', 'Hidden Fees, Ever'],
  ['Free', 'Ship Under 100 lbs'],
];

export default function Landing() {
  const { user } = useAuth();

  return (
    <div className="app">
      <div className="main">
        <section className="hero">
          <div className="hero-grid">
            <div>
              <div className="hero-tag">Authenticated · Sourced · Documented</div>
              <h1>
                Vintage Hemi parts <em>for the</em> ruthlessly correct.
              </h1>
              <p className="hero-body">
                A subscription marketplace for restoration shops and enthusiasts who refuse to accept
                "close enough." Every part is photographed, casting-verified, and documented before
                it ever appears in your inventory feed — backed by promises most platforms won't make.
              </p>
              <div className="hero-actions">
                <Link to="/signin" className="btn">
                  Enter the Catalog →
                </Link>
                <a href="#tiers" className="btn ghost">
                  View Subscriptions
                </a>
              </div>
            </div>

            <div className="hero-card">
              <div className="price-headline">
                The SWC Promise
                <small>Every Subscriber. Every Part.</small>
              </div>
              <div className="feature-strip">
                {SWC_PROMISE.map((p) => (
                  <div key={p.title} className="feature-strip-item">
                    <div className="num">✓</div>
                    <div className="txt">
                      <strong>{p.title}</strong>
                      {p.detail}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="stat-row" style={{ marginTop: 0 }}>
          {STATS.map(([v, l]) => (
            <div key={l} className="stat">
              <div className="stat-value">{v}</div>
              <div className="stat-label">{l}</div>
            </div>
          ))}
        </section>

        {/* Heritage Archive teaser — drives sign-ups by promising early access */}
        <section className="heritage-banner">
          <div>
            <div className="heritage-banner-eyebrow">New · Coming Q3 2026</div>
            <div className="heritage-banner-title">
              <em>The Heritage Archive</em>
            </div>
            <p className="heritage-banner-sub">
              5,000+ never-seen negatives from 17 pro drag racing photographers — Hot Rod,
              National Dragster, Drag News, Car Craft. Subscribers get founding-member access
              and a first look.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {user ? (
              <Link to="/heritage" className="btn">Preview the Archive →</Link>
            ) : (
              <Link to="/signin" className="btn">Sign in to Preview →</Link>
            )}
          </div>
        </section>

        <section id="tiers">
          <div className="eyebrow">Subscriptions · Every Tier Includes the SWC Promise</div>
          <h2 className="h-display" style={{ marginBottom: 8 }}>
            Pick Your Tier.
          </h2>
          <p className="lead" style={{ marginBottom: 36 }}>
            Cancel anytime. Built by Mopar people, for Mopar people. Every plan includes the full
            SWC Promise — no excessive fees, 100% guarantee, no-questions returns, free ship under
            100 lbs, and a tech line on every part sold.
          </p>
          <div className="tiers">
            {TIERS.map((t) => (
              <TierCard key={t.id} tier={t} />
            ))}
          </div>
        </section>

        <section className="landing-cta">
          <div className="eyebrow">Try It Risk-Free</div>
          <h2 className="h-title">
            Authenticated parts. Honest pricing. Real people on the phone.
          </h2>
          <p className="lead" style={{ margin: '0 auto 28px' }}>
            Browse the inventory. Scan a VIN. Build a real quote with editable line items, shipping
            weights, and currency conversion. Every part backed by the SWC Promise — no excessive
            fees, 100% guarantee, no-questions returns.
          </p>
          <Link to="/signin" className="btn">
            Enter the Catalog →
          </Link>
        </section>
      </div>
    </div>
  );
}
